import {
  OngoingSection,
  QuestionProgressStatus,
  QuestionTimeSpent,
  SectionProgressStatus,
  SectionTimeSpent
} from "../types/assessmentOngoing";
import { ShuffleObject } from "./shuffleObject";

export const ParseAssessmentSectionsList = (
  ongoingSections: OngoingSection[],
  giveShuffledOptionsForObjectiveQuestions: boolean
) => {
  const assessmentProgressPayload: {
    [sectionId: string]: SectionProgressStatus;
  } = {};
  const candidateSolutionsPayload: { [questionId: string]: string[] } = {};
  const candidateFibSolutionsPayload: {
    [questionId: string]: Record<string, string>;
  } = {};
  const assessmentTimeSpent: { [sectionId: string]: SectionTimeSpent } = {};

  const shuffledOptionsForQuestions: {
    [questionId: string]: Record<string, string>;
  } = {};

  if (!ongoingSections || ongoingSections.length === 0)
    return {
      assessmentProgressPayload,
      candidateSolutionsPayload,
      candidateFibSolutionsPayload,
      assessmentTimeSpent,
      shuffledOptionsForQuestions
    };

  ongoingSections.forEach((section) => {
    const sectionStatus = (() => {
      if (section.userCompletedAt) return "completed";
      else if (section.userStartedAt) return "in_progress";
      else return "not_started";
    })();

    const requiredQuestionsProgress: {
      [questionId: string]: QuestionProgressStatus;
    } = {};
    const requiredQuestionsTimeSpent: {
      [questionId: string]: QuestionTimeSpent;
    } = {};

    section.questions.forEach((question) => {
      const questionStatus: QuestionProgressStatus["status"] = (() => {
        if (question.userCompletedAt || question.codingAttempted)
          return "completed";
        else if (question.userStartedAt === null) return "not_started";
        else return "unanswered";
      })();
      requiredQuestionsProgress[question.questionId] = {
        status: questionStatus,
        flagged: question.flagged,
        orderInSection: question.orderInSection
      };

      requiredQuestionsTimeSpent[question.questionId] = {
        value: question.timeSpent
      };

      // For candidate Solutions
      if (question.subType === "fib") {
        const existingFibSolution = question.userFibSolutions;
        candidateFibSolutionsPayload[question.questionId] = existingFibSolution;
      } else {
        const existingSolution = question.userSolutions;
        candidateSolutionsPayload[question.questionId] = existingSolution;
      }

      // Shuffle options of objective questions if randomization is required
      if (
        giveShuffledOptionsForObjectiveQuestions &&
        question.type === "objective" &&
        question.subType !== "fib"
      ) {
        const shuffledOptions = ShuffleObject(question.options);
        shuffledOptionsForQuestions[question.questionId] = shuffledOptions;
      }
    });

    assessmentProgressPayload[section.sectionId] = {
      status: sectionStatus,
      questions: requiredQuestionsProgress
    };

    assessmentTimeSpent[section.sectionId] = {
      value: section.timeSpent,
      questions: requiredQuestionsTimeSpent
    };
  });
  return {
    assessmentProgressPayload,
    candidateSolutionsPayload,
    candidateFibSolutionsPayload,
    assessmentTimeSpent,
    shuffledOptionsForQuestions
  };
};
